import NewsParagraph from "../components/NewsParagraph.tsx";
import ArticleContainer from "../components/ArticleContainer.tsx";

function Long1() {
  return (
    <ArticleContainer>
      <NewsParagraph>
        AI Deepfake Sparks International Celebrity Scandal
      </NewsParagraph>
      <NewsParagraph>August 10, 2024</NewsParagraph>
      <NewsParagraph>
        LOS ANGELES, CA (AP) – In a sensational turn of events, a deepfake video
        featuring international film star James Harrington has sparked a global
        scandal, leading to canceled projects, plummeting stock values for
        associated studios, and widespread public outrage. The video, which
        appeared to show Harrington making deeply offensive remarks about
        various ethnic and religious groups, was later proven to be entirely
        AI-generated – but not before causing significant damage to the actor's
        reputation and career.
      </NewsParagraph>
      <NewsParagraph>
        The deepfake first appeared on an anonymous social media account and
        quickly spread across multiple platforms, garnering millions of views
        within hours. The video showed what appeared to be Harrington in a
        private setting, making statements that contradicted his long-standing
        public image as an advocate for diversity and inclusion.
      </NewsParagraph>
      <NewsParagraph>
        "The technology used to create this deepfake was extraordinarily
        sophisticated," said Dr. Aisha Patel, a digital forensics expert who
        analyzed the video. "It perfectly replicated Harrington's voice,
        mannerisms, and even subtle facial expressions. Without specialized
        tools, it would be virtually impossible for the average viewer to
        identify it as fake."
      </NewsParagraph>
      <NewsParagraph>
        The fallout was swift and severe. Within 24 hours of the video's
        release, Harrington was dropped from two major film projects, lost
        several endorsement deals, and faced intense public backlash. The stock
        price of Meridian Studios, which had recently signed Harrington for a
        $200 million multi-film deal, fell by 15% in a single day.
      </NewsParagraph>
      <NewsParagraph>
        Despite Harrington's immediate denials and the subsequent verification
        by multiple independent experts that the video was fabricated, the
        damage had already been done. A poll conducted three days after the
        incident revealed that 42% of respondents still believed the content was
        authentic, even after being informed it was AI-generated.
      </NewsParagraph>
      <NewsParagraph>
        "This case illustrates the dangerous new reality we're facing," said
        media analyst Marcus Chen. "The combination of highly convincing
        deepfakes and the speed at which content spreads online creates a
        perfect storm where the lie travels halfway around the world before the
        truth has a chance to get its shoes on."
      </NewsParagraph>
      <NewsParagraph>
        Harrington has since announced legal action against the platforms that
        hosted the video, arguing they failed to implement adequate safeguards
        against harmful deepfakes. The FBI has also launched an investigation to
        identify those responsible for creating and distributing the fake.
      </NewsParagraph>
      <NewsParagraph>
        This incident has reignited calls for stronger regulation of
        AI-generated content and more robust verification systems for digital
        media. Several lawmakers have cited the Harrington case as evidence of
        the urgent need for legislation specifically addressing the creation and
        distribution of malicious deepfakes.
      </NewsParagraph>
      <NewsParagraph>
        As Harrington works to rebuild his reputation, the incident serves as a
        stark warning about the potential for AI to cause real-world harm to
        individuals and institutions. It also raises troubling questions about
        the future of truth in a world where seeing – and hearing – can no
        longer be reliably believed.
      </NewsParagraph>
    </ArticleContainer>
  );
}

export default Long1;
